// extracted by mini-css-extract-plugin
module.exports = {"task-block":"styles_task-block__1kKFj"};